class ComponentContact extends customElements.get("component-tabs") {
  static EMBED_ORIGIN = "https://form.jotform.com";

  static MAX_EMBED_HEIGHT = 2000;

  connectedCallback() {
    if (!this.elements.tabs) {
      return;
    }

    super.connectedCallback();

    this.addDirectEvent("hashchange", window, () => this.selectFromHash());

    this.addDirectEvent("message", window, (event) => this.receiveEmbedMessage(event));

    this.selectFromHash();
  }

  select(tab) {
    super.select(tab);

    this.loadEmbed(document.getElementById(tab.getAttribute("aria-controls")));

    this.elements.tabs.forEach((element) => {
      element.classList.toggle("state--active", element === tab);
    });

    this.querySelector("component-collection-nav")?.measure();
  }

  loadEmbed(panel) {
    const frame = panel?.querySelector("[data-src]");

    if (frame) {
      frame.src = frame.dataset.src;

      delete frame.dataset.src;
    }
  }

  receiveEmbedMessage(event) {
    if (event.origin !== ComponentContact.EMBED_ORIGIN || typeof event.data !== "string") {
      return;
    }

    const frame = this.elements.embeds?.find((element) => element.contentWindow === event.source);

    if (!frame) {
      return;
    }

    const [command, value] = event.data.split(":");

    if (command === "setHeight") {
      this.resizeEmbed(frame, value);
    }

    if (command === "scrollIntoView") {
      frame.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }

  resizeEmbed(frame, value) {
    const height = parseInt(value, 10);

    if (!Number.isFinite(height)) {
      return;
    }

    frame.style.height = `${Math.min(height, ComponentContact.MAX_EMBED_HEIGHT)}px`;
  }

  selectFromHash() {
    const hash = decodeURIComponent(window.location.hash.slice(1));

    if (!hash) {
      return;
    }

    const tab = this.elements.tabs.find((element) => {
      const panel = document.getElementById(element.getAttribute("aria-controls"));

      return element.dataset.contactHandle === hash || panel?.querySelector(`#${CSS.escape(hash)}`);
    });

    if (tab) {
      this.select(tab);
    }
  }
}

customElements.define("component-contact", ComponentContact);
